import { Button, ButtonVariant, LayoutHeader, LayoutWithSidebar, Spinner } from '@swivl-mono/ui';
import RolesModel from '../../../Models/Roles/Roles.Model';
import { useEffect } from 'react';
import { Link, Outlet, useParams } from 'react-router-dom';
import { RoleInterface, RoleInterfaceMap } from '@swivl-mono/types';
import _ from 'lodash';
import { Member } from '../../../Models/Member/Member.Current';
import { RoleSettingsDetailsView } from './Role.Settings.Details.View';
import ModalModel from '../../../Models/Modal/Modal.Model';
import { CreateNewRoleModal } from './Modal/CreateNewRole.Modal';
import { SidebarLink } from '../../../Components/SidebarLink/SidebarLink';
function RolesListWithHeading(props: { roles: RoleInterfaceMap, heading: string }) {
  const { roles, heading } = props;
  return <div className="flex flex-col mb-3">

    <label className="ml-3">{heading}</label>
    {Object.values(roles).map((role: RoleInterface) => {
      {
        return (
          <SidebarLink to={'/settings/roles/' + role.id} key={role.id} height={38}>
            {role.name}
          </SidebarLink>
        );
      }
    })}
  </div>
}

export function RolesSettingsView() {
  const { roles, parentRoles } = RolesModel.useState();
  let params = useParams();
  let roleId = params.roleId;
  let role: RoleInterface | undefined = undefined;
  if (roleId) {
    for (let key in roles) {
      if (roles[key].id === parseInt(roleId)) {
        role = roles[key];
      }
    }
    if (!role) {
      for (let key in parentRoles) {
        if (parentRoles[key].id === parseInt(roleId)) {
          role = parentRoles[key];
        }
      }
    }
  }




  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col mt-5">

          {roles ? (
            <>
              {parentRoles && !_.isEmpty(parentRoles) && <RolesListWithHeading roles={parentRoles} heading="Default Roles" />}
              {roles && !_.isEmpty(roles) && <RolesListWithHeading roles={roles} heading={Member.isInParentOrg ? "Roles" : "Custom Roles"} />}
              <Button
                className="m-2"
                variant={ButtonVariant.DASHED}
                onClick={() => {
                  ModalModel.showModalWithContent(<h2>Create New Role</h2>, <CreateNewRoleModal />)
                }}
              >
                Create New Role
              </Button>

            </>
          ) : (
            <div className="flex align-center justify-center">
              <Spinner />{' '}
            </div>
          )}
        </div>
      }
      content={
        <div>
          {role ? <RoleSettingsDetailsView key={role.id} role={role} /> : null}
        </div>
      }
    />
  );
}
